var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_80)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 77V1H77V77H1Z",
    fill: "white",
    stroke: "#2FC77E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5234 45.0937C39.5234 44.805 39.2886 44.5703 39 44.5703C38.7113 44.5703 38.4766 44.805 38.4766 45.0937C38.4766 45.3823 38.7113 45.6171 39 45.6171C39.2886 45.6171 39.5234 45.3823 39.5234 45.0937Z",
    fill: "white",
    stroke: "#2FC77E",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_80)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_29_80",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 77V1.00023H1V77H76.9998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_29_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6962 22.9309L1.52344 17.6721L38.9999 5.48459L76.4763 17.6721L60.3036 22.9309L38.9999 29.8595L17.6962 22.9309Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0874 44.8151C50.7256 44.2788 54.3758 43.0982 55.2837 42.3852",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 23.0041V45.0938C17.6719 48.4591 27.2208 51.1876 38.9999 51.1876C50.7791 51.1876 60.328 48.4591 60.328 45.0938V23.0041",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4294 51.1876C75.1128 51.1876 76.4763 52.5511 76.4763 54.2344C76.4763 55.9178 75.1128 57.2813 73.4294 57.2813C71.746 57.2813 70.3826 55.9178 70.3826 54.2344C70.3826 52.5511 71.746 51.1876 73.4294 51.1876Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4294 18.9411V51.1876",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4763 72.5156L73.4294 57.2813L70.3826 72.5156H76.4763Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.de87d570a7d8959aa9b6bef1857629fc.svg";
export { ForwardRef as ReactComponent };